/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Status_InvalidInputs */



/**
* | output |
* | --- |
* | "Invalid" |
*
* @param {Api_Keys_Status_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_keys_status_invalid = /** @type {((inputs?: Api_Keys_Status_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Status_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ungültig")
	return /** @type {LocalizedString} */ ("Invalid")
});